import React from 'react';
import { List, UploadFile } from 'antd';
import { Typography } from 'antd';
import styled from '@emotion/styled';
import { FileItem } from 'app/pages/TemplateManagment/components/FormItems/Uploader';

const Title = styled(Typography.Title)``;
const Container = styled.div`
  > h5 {
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0.005em;
    color: #232b3a;
  }
`;

const ReferenceFile = ({
  title,
  files
}: {
  title?: React.ReactNode;
  files: number[] | string[] | UploadFile[] | any[];
}) => {
  return (
    <Container>
      <Title level={5}>{title || 'Reference File:'}</Title>
      <List
        dataSource={files}
        renderItem={(file, index) => {
          return <FileItem key={index} file={file} />;
        }}
      ></List>
    </Container>
  );
};

export default ReferenceFile;
